import { useMemo } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

import { LimitedChipItems } from "app/pages/sales-intelligence/common-components/filters-panel";
import { MAX_CHIPS_GROUP_AMOUNT } from "app/pages/sales-intelligence/common-components/filters-panel/constants";

/** Filter chips default to 29 chars; Industry Plus paths need more room in this modal only. */
const IMPACT_REPORT_CHIP_TEXT_MAX_LENGTH = 44;

type IndustryValuesCellProps = {
    readonly values: readonly string[];
    readonly dataAutomation: string;
};

export const IndustryValuesCell = ({ values, dataAutomation }: IndustryValuesCellProps) => {
    const chipItems = useMemo(() => values.map((value, index) => ({ id: `${value}-${index}`, text: value })), [values]);

    if (chipItems.length === 0) {
        return null;
    }

    return (
        <Flex
            flexWrap="wrap"
            data-automation={dataAutomation}
            aria-label={values.join(", ")}
        >
            <LimitedChipItems
                items={chipItems}
                maxItems={MAX_CHIPS_GROUP_AMOUNT}
                maxChipTextSize={IMPACT_REPORT_CHIP_TEXT_MAX_LENGTH}
                hideActionButton
                isTabExpanded
            />
        </Flex>
    );
};
